/**
 * 拣货域枚举常量定义
 */

// 拣选任务状态
export enum PickingTaskStatus {
  IN_PROGRESS = 'IN_PROGRESS',     // 进行中
  COMPLETED = 'COMPLETED',         // 已完成
  CANCELLED = 'CANCELLED',         // 已取消
}

export const PickingTaskStatusOptions = [
  { value: PickingTaskStatus.IN_PROGRESS, label: 'picking.taskStatus.inProgress', color: 'processing' },
  { value: PickingTaskStatus.COMPLETED, label: 'picking.taskStatus.completed', color: 'green' },
  { value: PickingTaskStatus.CANCELLED, label: 'picking.taskStatus.cancelled', color: 'red' },
];

// 任务来源
export enum TaskSource {
  WAVE = 'WAVE',                   // 波次生成
  MANUAL = 'MANUAL',               // 手工创建
}

export const TaskSourceOptions = [
  { value: TaskSource.WAVE, label: 'picking.taskSource.wave' },
  { value: TaskSource.MANUAL, label: 'picking.taskSource.manual' },
];

// 拣选明细状态
export enum PickingDetailStatus {
  PENDING = 'PENDING',             // 待拣
  PICKED = 'PICKED',               // 已拣
  SHORTAGE = 'SHORTAGE',           // 缺货
  REPLACED = 'REPLACED',           // 已替换
  CANCELED = 'CANCELED',           // 已取消（商品不再进行拣选，拣选数量为0）
  REPICKED = 'REPICKED',           // 重新拣选（调整了拣选数量）
  CONFIRMED_SHORT = 'CONFIRMED_SHORT', // 确认缺货（商品数量为0，实际拣选数量为0，已确认）
}

export const PickingDetailStatusOptions = [
  { value: PickingDetailStatus.PENDING, label: 'picking.detailStatus.pending', color: 'default' },
  { value: PickingDetailStatus.PICKED, label: 'picking.detailStatus.picked', color: 'green' },
  { value: PickingDetailStatus.SHORTAGE, label: 'picking.detailStatus.shortage', color: 'red' },
  { value: PickingDetailStatus.REPLACED, label: 'picking.detailStatus.replaced', color: 'orange' },
  { value: PickingDetailStatus.CANCELED, label: 'picking.detailStatus.canceled', color: 'default' },
  { value: PickingDetailStatus.REPICKED, label: 'picking.detailStatus.repicked', color: 'blue' },
  { value: PickingDetailStatus.CONFIRMED_SHORT, label: 'picking.detailStatus.confirmedShort', color: 'red' },
];

// 商品类型
export enum ItemType {
  NORMAL = 'NORMAL',               // 非称重
  WEIGHTED = 'WEIGHTED',           // 称重
}

export const ItemTypeOptions = [
  { value: ItemType.NORMAL, label: 'picking.itemType.normal' },
  { value: ItemType.WEIGHTED, label: 'picking.itemType.weighted' },
];

// 温层
export enum TemperatureZone {
  NORMAL = 'NORMAL',               // 常温
  CHILLED = 'CHILLED',             // 冷藏
  FROZEN = 'FROZEN',               // 冷冻
}

export const TemperatureZoneOptions = [
  { value: TemperatureZone.NORMAL, label: 'picking.temperatureZone.normal', color: 'default' },
  { value: TemperatureZone.CHILLED, label: 'picking.temperatureZone.chilled', color: 'blue' },
  { value: TemperatureZone.FROZEN, label: 'picking.temperatureZone.frozen', color: 'cyan' },
];

// 缺货原因（value 与后端/PDA 端存储的 code 保持一致）
export enum ShortageReason {
  STOCK_OH_ZERO_OR_NEGATIVE = 'STOCK_OH_ZERO_OR_NEGATIVE',
  HAS_STOCK_BUT_NOT_FOUND = 'HAS_STOCK_BUT_NOT_FOUND',
  INSUFFICIENT_QUANTITY = 'INSUFFICIENT_QUANTITY',
  UNABLE_TO_FULFILL_REQUESTED_WEIGHT = 'UNABLE_TO_FULFILL_REQUESTED_WEIGHT', // 无法按订单重量拣货
  QUALITY_UNSUITABLE_OR_EXPIRED = 'QUALITY_UNSUITABLE_OR_EXPIRED',
  CUSTOMER_CHANGE_PRODUCT = 'CUSTOMER_CHANGE_PRODUCT',
  CUSTOMER_TRIMMING_COOKING = 'CUSTOMER_TRIMMING_COOKING',
  NO_IMAGE_OR_NAME_ON_APP = 'NO_IMAGE_OR_NAME_ON_APP',
}

export const ShortageReasonOptions = [
  { value: ShortageReason.STOCK_OH_ZERO_OR_NEGATIVE, label: 'picking.shortageReason.stockOhZeroOrNegative' },
  { value: ShortageReason.HAS_STOCK_BUT_NOT_FOUND, label: 'picking.shortageReason.hasStockButNotFound' },
  { value: ShortageReason.INSUFFICIENT_QUANTITY, label: 'picking.shortageReason.insufficientQuantity' },
  { value: ShortageReason.UNABLE_TO_FULFILL_REQUESTED_WEIGHT, label: 'picking.shortageReason.unableToFulfillRequestedWeight' },
  { value: ShortageReason.QUALITY_UNSUITABLE_OR_EXPIRED, label: 'picking.shortageReason.qualityUnsuitableOrExpired' },
  { value: ShortageReason.CUSTOMER_CHANGE_PRODUCT, label: 'picking.shortageReason.customerChangeProduct' },
  { value: ShortageReason.CUSTOMER_TRIMMING_COOKING, label: 'picking.shortageReason.customerTrimmingCooking' },
  { value: ShortageReason.NO_IMAGE_OR_NAME_ON_APP, label: 'picking.shortageReason.noImageOrNameOnApp' },
];

// 取消订单原因（value 与后端/PDA 端存储的 code 保持一致）
export enum CancelReason {
  OUT_OF_STOCK_NO_SUBSTITUTE = 'OUT_OF_STOCK_NO_SUBSTITUTE',
  CUSTOMER_CANCEL = 'CUSTOMER_CANCEL',
  SYSTEM_ISSUE = 'SYSTEM_ISSUE',
  NO_RIDER = 'NO_RIDER',
  WRONG_PROMOTION_PRICE = 'WRONG_PROMOTION_PRICE',
  NOT_AVAILABLE_AT_BRANCH = 'NOT_AVAILABLE_AT_BRANCH',
  WEATHER_ISSUE = 'WEATHER_ISSUE',
  ROAD_CLOSURE = 'ROAD_CLOSURE',
  WRONG_LOCATION = 'WRONG_LOCATION',
  WHOLESALE_CUSTOMER = 'WHOLESALE_CUSTOMER',
  CUSTOMER_TRIMMING_COOKING = 'CUSTOMER_TRIMMING_COOKING',
  ORDER_BELOW_MINIMUM = 'ORDER_BELOW_MINIMUM',
}

export const CancelReasonOptions = [
  { value: CancelReason.OUT_OF_STOCK_NO_SUBSTITUTE, label: 'picking.cancelReason.outOfStockNoSubstitute' },
  { value: CancelReason.CUSTOMER_CANCEL, label: 'picking.cancelReason.customerCancel' },
  { value: CancelReason.SYSTEM_ISSUE, label: 'picking.cancelReason.systemIssue' },
  { value: CancelReason.NO_RIDER, label: 'picking.cancelReason.noRider' },
  { value: CancelReason.WRONG_PROMOTION_PRICE, label: 'picking.cancelReason.wrongPromotionPrice' },
  { value: CancelReason.NOT_AVAILABLE_AT_BRANCH, label: 'picking.cancelReason.notAvailableAtBranch' },
  { value: CancelReason.WEATHER_ISSUE, label: 'picking.cancelReason.weatherIssue' },
  { value: CancelReason.ROAD_CLOSURE, label: 'picking.cancelReason.roadClosure' },
  { value: CancelReason.WRONG_LOCATION, label: 'picking.cancelReason.wrongLocation' },
  { value: CancelReason.WHOLESALE_CUSTOMER, label: 'picking.cancelReason.wholesaleCustomer' },
  { value: CancelReason.CUSTOMER_TRIMMING_COOKING, label: 'picking.cancelReason.customerTrimmingCooking' },
  { value: CancelReason.ORDER_BELOW_MINIMUM, label: 'picking.cancelReason.orderBelowMinimum' },
];

// 客户确认状态
export enum CustomerConfirmStatus {
  PENDING = 'PENDING',
  CONFIRMED = 'CONFIRMED',
  REJECTED = 'REJECTED',
}

export const CustomerConfirmStatusOptions = [
  { value: CustomerConfirmStatus.PENDING, label: 'picking.confirmStatus.pending', color: 'orange' },
  { value: CustomerConfirmStatus.CONFIRMED, label: 'picking.confirmStatus.confirmed', color: 'green' },
  { value: CustomerConfirmStatus.REJECTED, label: 'picking.confirmStatus.rejected', color: 'red' },
];
